import { Session } from 'types/listings';

const getUniqueDaySessions = (sessions: Session[]): Session[] => {
  if (!sessions || sessions.length === 0) return [];

  const uniqueDaysMap = new Map<string, Session>();

  // Keep only the first session for each unique day
  // This is needed for multi-night bookings where we need exactly one session per night
  sessions.forEach((session) => {
    const dateKey = new Date(session.startDateTime).toDateString();
    if (!uniqueDaysMap.has(dateKey)) {
      uniqueDaysMap.set(dateKey, session);
    }
  });

  const uniqueSessions = Array.from(uniqueDaysMap.values());

  return uniqueSessions.sort(
    (a, b) =>
      new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime(),
  );
};

export default getUniqueDaySessions;
